import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { CoverageServerAction } from '../../coverageServer.action';

export const CoverageServerListSubscriber: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(CoverageServerAction.loadList.started());
  }, [dispatch]);

  return null;
};
